module.exports = __webpack_public_path__ + "media/images/icon__community@3x-62cd01f4bec7fc5b3d447a4f0b1cf5ab.png";